import React from 'react';

const AttributesDefinition = () => (
  <div className="AttributesDefinition" />
);

export default AttributesDefinition;
